<template>
  <v-navigation-drawer
    permanent
    value
    height="auto"
    width="264"
    class="chat-drawer"
  >
    <template v-slot:prepend>
      <div v-if="hasHeader" class="chat-drawer__header pt-1">
        <slot name="header"></slot>
      </div>
    </template>
    <chat-drawer-list
      :chats="chats"
      :last-chats-messages="lastChatsMessages"
      :chats-unreaded-messages="chatsUnreadedMessages"
      :current-chat="currentChat"
      :current-user="currentUser"
      :roles="roles"
      :is-admin="isAdmin"
      :chat-id-param="chatIdParam"
      @itemSelected="$emit('itemSelected', $event)"
      @toggleChannelIsPinned="$emit('toggleChannelIsPinned', $event)"
      @setChatArchive="$emit('setChatArchive', $event)"
    />
    <template v-slot:append>
      <div v-if="hasFooter" class="chat-drawer__footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import ChatDrawerList from '@/components/ChatDrawerList.vue'

export default {
  name: 'ChatDrawer',
  components: {
    ChatDrawerList,
  },
  props: {
    chats: {
      type: Array,
      default: () => {},
    },
    hasHeader: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    chatsUnreadedMessages: {
      type: Object,
      default: () => ({}),
    },
    lastChatsMessages: {
      type: Object,
      default: () => ({}),
    },
    currentChat: {
      type: [String, Number],
      default: '',
    },
    currentUser: {
      type: String,
      default: '',
    },
    roles: {
      type: Object,
      default: () => ({}),
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chatIdParam() {
      return this.$route.params.chatId
    }
  }
}
</script>
<style lang="scss" scoped>
.chat-drawer {
  min-width: 264px !important;
  max-width: 264px !important;
  background: $bh-blue--4;
  ::v-deep .v-navigation-drawer__border {
    display: none;
  }
}
</style>
